import { useLayoutEffect } from 'react';

/** "Paige v6.2.150 - Job: Accounts Payable": the version says which build a person is on (owner, 2026-11-04). */
export function workspaceWindowTitle(jobName?: string, appVersion?: string): string {
  const name = (jobName ?? '')
    .replace(/[\u0000-\u001f\u007f]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
  const version = /^\d+(\.\d+){1,3}$/.test((appVersion ?? '').trim())
    ? ` v${appVersion!.trim()}`
    : '';
  return name ? `Paige${version} - Job: ${name}` : `Paige${version}`;
}

/** Only the primary App uses this hook. Detached windows keep their native
 * panel titles; no privileged renderer window API is needed. */
export function useWorkspaceWindowTitle(jobName?: string, appVersion?: string) {
  const title = workspaceWindowTitle(jobName, appVersion);
  useLayoutEffect(() => {
    const previous = document.title;
    document.title = title;
    return () => {
      if (document.title === title) document.title = previous;
    };
  }, [title]);
}
